import { makeAutoObservable } from 'mobx'
import { findLast } from 'reusable/mobx-store-utils/utils/utils'
import { removeAllItemsFromArray } from 'reusable/utils/array-utils'

type FieldType<T> = keyof T

export class FormErrorHandler<T> {
   errors = {} as Partial<Record<FieldType<T>, FieldErrorHandler>>

   constructor() {
      makeAutoObservable(this)
   }

   /** whether there's any error in any field */
   get hasError() {
      for (const field of Object.keys(this.errors)) {
         if (this.getFieldErrorHandler(field as keyof T).hasError) {
            return true
         }
      }
      return false
   }

   getFieldErrorHandler(field: FieldType<T>) {
      if (!this.errors[field]) {
         this.errors[field] = new FieldErrorHandler()
      }
      return this.errors[field]!
   }

   /** reset all errors */
   reset() {
      for (const field of Object.keys(this.errors)) {
         this.getFieldErrorHandler(field as keyof T).reset()
      }
   }
}

export class FieldErrorHandler {
   errors: string[] = []

   constructor() {
      makeAutoObservable(this)
   }

   get hasError() {
      return !!this.errors.length
   }

   get error() {
      return findLast(this.errors)
   }

   reset() {
      removeAllItemsFromArray(this.errors)
   }

   addError(e: string) {
      this.errors.push(e)
   }

   setError(e: string) {
      this.reset()
      this.addError(e)
   }
}

export default FormErrorHandler
